import React, { memo } from 'react'
import {
  Row,
  Container,
  Link,
  Button,
  HeadingText,
  CaptionText,
  BodyText,
} from '@paypalcorp/pp-react'
import { Router } from '@reach/router'
import { Message } from '@paypalcorp/worldready-react'
import Home from './status-content'
import { PYPL_CONTACTUS_URL, SIGNUP_LINK } from '../../constants/constants'
import DATAPRIVACY_FPTI from '../../config/data-privacy-fpti'

const RetriggerSMSHome = memo(() => {
  const { CLOSED_ACCOUNT = {} } = DATAPRIVACY_FPTI

  return (
    <div className="retrigger-sms logged-out-container">
      <Container form>
        <Row>
          <div className="full-width">
            <Router>
              <Home path="/" dsrFpti={CLOSED_ACCOUNT} />
            </Router>

            <section className="sms-footer">
              <HeadingText size="sm">
                <Message id="closedAccountPages.passwordsent.footer.title" />
              </HeadingText>
              <CaptionText>
                <Message
                  id="closedAccountPages.passwordsent.footer.link"
                  link={(innerMessage) => (
                    <Link name="faq" href={PYPL_CONTACTUS_URL}>
                      {innerMessage}
                    </Link>
                  )}
                />
              </CaptionText>
            </section>

            <section className="sms-footer signuplink">
              <BodyText size="sm">
                <Message id="closedAccountPages.passwordsent.footer.p1" />
              </BodyText>
              <CaptionText>
                <Message id="closedAccountPages.passwordsent.footer.p2" />
              </CaptionText>
              <BodyText>
                <Button tertiary>
                  <Link href={SIGNUP_LINK}>
                    <Message id="closedAccountPages.passwordsent.footer.signuplink" />
                  </Link>
                  <span className="tertiary-button--icon" />
                </Button>
              </BodyText>
            </section>
          </div>
        </Row>
      </Container>
    </div>
  )
})
RetriggerSMSHome.displayName = 'RetriggerSMSHome'

export default RetriggerSMSHome
